import React from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Toaster.scss";

const ToastContext = () => {
    return (
        <ToastContainer position="top-center" autoClose={3000} hideProgressBar={true} closeOnClick draggable pauseOnHover limit={1} />
    );
};

export const showSuccessToast = (message) => {
    toast.success(message, { icon: false });
};

export const showErrorToast = (message) => {
    toast.error(message, { icon: false });
};

export default ToastContext;